/* eslint-disable max-statements */
import { Tooltip } from 'primereact/tooltip';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Outlet } from 'react-router';
import { useNavigate } from 'react-router-dom';

import ttcLogoUrl from '../../assets/ttecVectorLogo.png';
import {
    ACTIONPLAN,
    ADMIN,
    AGENTROLE,
    CALLINSIGHT,
    CAMENU,
    COACHING,
    COMPENSATION,
    EDSDASHBOARD,
    GAMEPLAN, // HOMEPAGE,
    LANDINGPAGE,
    MANAGERDASHBOARD,
    MANAGERROLE,
    MENUITEM_TOOL_TIPS,
    METRICSADMIN,
    MYMETRICS,
    ROLES,
    SCORECARDDASHBOARD,
    SCORECARDRULES,
    STACKRANK,
    SUPERVISORROLE,
} from '../../constants';
import {
    selectCurrentEmpid,
    selectCurrentIsAdmin,
    selectCurrentIsEds,
    selectCurrentIsHC,
    selectCurrentRole,
    selectCurrentUser,
    selectCurrentUserManagerLevel,
    selectCurrentisComp,
    selectIsAllowCoachingInsight,
    selectIsDelegate,
    selectIsUserMoodMeterHidden,
    selectIsUserinPercepta,
    selectIsManagerRecentApprover,
    selectIsAllowCoachingActionModel,
} from '../../pages/login/authSlice';
import { ItemToolTip } from '../../utils/types';
import { logToServer } from '../logger/logger';
import { Footer } from './footer/Footer';
import { Header } from './header/Header';
import './layout.scss';
import { LeftDrawerEmojis } from './leftDrawerEmojis';
import WebRtcDashboard from '../webRTC/WebRtcDashboard';

export const Layout = () => {
    const currentUserName = useSelector(selectCurrentUser);
    const [sideNameContent, setSideNameContent] = useState(false);
    const [col1, setCol1] = useState(1);
    const [col11, setCol11] = useState(11);
    const [col6, setCol6] = useState(12);
    const [firstCol, setFirstCol] = useState('4%');
    const [secondCol, setSecondCol] = useState('94.6%');
    const [visibleContent, setVisibleContent] = useState(false);
    const [activePerformanceMainMenu, setactivePerformanceMainMenu] = useState(false);
    const [activePerformanceView, setActivePerformanceView] = useState(false);
    // const [activeManagerMenu, setActiveManagerMenu] = useState(false);
    // const [activeManagerView, setActiveManagerView] = useState(false);
    const [activeCompView, setActiveCompView] = useState(false);
    const [activeCorrectiveActionMenu, setActiveCorrectiveActionMenu] = useState(false);
    const [activeCorrectiveActionView, setActiveCorrectiveActionView] = useState(false);
    const [activeMyMetricsLink, setActiveMyMetricsLink] = useState(false);
    const [activeScoreCardLink, setActiveScoreCardLink] = useState(false);
    const [activeEdsLink, setEdsLink] = useState(false);
    const [activeCompLink, setCompLink] = useState(false);
    const [activeCompMenu, setActiveCompMenu] = useState(false);
    const [activeManagerLink, setActiveManagerLink] = useState(false);
    const [activeCaMenuLink, setActiveCaMenuLink] = useState(false);
    const [activeScorecardRules, setActiveScorecardRules] = useState(false);
    const [adminWorkstreamPrep, setAdminWorkstreamPrep] = useState(false);
    const [coachingView, setCoachingView] = useState(false);
    const [callInsightView, setCallInsightView] = useState(false);
    const [activeHomePageView, setActiveHomePageView] = useState(false);
    const [gamePlanView, setGamePlanView] = useState(false);
    const [stackRankView, setStackRankView] = useState(false);
    const [activeAdminMenu, setActiveAdminMenu] = useState(false);
    const [activeAdminView, setActiveAdminView] = useState(false);
    const [activeMetricsAdminLink, setActiveMetricsAdminLink] = useState(false);
    const [activeActionPlanLink, setActiveActionPlanLink] = useState(false);
    const [activeCoachingMenu, setActiveCoachingMenu] = useState(false);
    const [activeCoachingView, setActiveCoachingView] = useState(false);

    const isEds = useSelector(selectCurrentIsEds);
    const isAdmin = useSelector(selectCurrentIsAdmin);
    const isComp = useSelector(selectCurrentisComp);
    const isDelegate = useSelector(selectIsDelegate);
    const role = useSelector(selectCurrentRole);
    const userManagerLevel = useSelector(selectCurrentUserManagerLevel);
    const empId = useSelector(selectCurrentEmpid);
    const isHC = useSelector(selectCurrentIsHC);
    const isAllowCoachingInsight = useSelector(selectIsAllowCoachingInsight);
    const isUserinPercepta = useSelector(selectIsUserinPercepta);
    const isAllowCoachingActionModel = useSelector(selectIsAllowCoachingActionModel);
    const isUserMoodMeterHidden = useSelector(selectIsUserMoodMeterHidden);
    const isManagerRecentApprover = useSelector(selectIsManagerRecentApprover);
    const navigate = useNavigate();
    const { pathname } = window.location;

    useEffect(() => {
        if (empId !== null) logToServer(empId, 'Page: ' + window.location.pathname.replace('/', ''));
    }, [pathname]);

    useEffect(() => {
        let activePerformanceMainMenu = false;
        let activeMyMetricsLink = false;
        let activeScoreCardLink = false;
        let edsLink = false;
        let activeCompLink = false;
        let activeScorecardRule = false;
        let managerLink = false;
        let activeCorrectiveAction = false;
        let activeAdmin = false;
        let activeCoaching = false;
        let activeCallInsight = false;
        let activeCaMenuLink = false;
        let activeHomePage = false;
        let activeGamePlanPage = false;
        let activeStackRankPage = false;
        let activeAdmnMenu = false;
        let activeMetricsAdmin = false;
        let activeActionPlan = false;
        let activeCoachingMenu = false;

        if (pathname === SCORECARDDASHBOARD) {
            activeScoreCardLink = true;
            activePerformanceMainMenu = true;
        } else if (pathname.includes(MYMETRICS)) {
            activeMyMetricsLink = true;
            activePerformanceMainMenu = true;
        } else if (pathname === EDSDASHBOARD) {
            edsLink = true;
            activePerformanceMainMenu = true;
        } else if (pathname === COMPENSATION) {
            activeCompLink = true;
        } else if (pathname === MANAGERDASHBOARD) {
            managerLink = true;
            activePerformanceMainMenu = true;
        } else if (pathname === SCORECARDRULES) {
            activeScorecardRule = true;
        } else if (pathname === COACHING) {
            activeCoaching = true;
            activeCoachingMenu = true;
        } else if (pathname === CALLINSIGHT) {
            activeCallInsight = true;
        } else if (pathname === ADMIN) {
            activeAdmin = true;
            activeAdmnMenu = true;
        } else if (pathname === CAMENU) {
            activeCorrectiveAction = true;
            activeCaMenuLink = true;
        } else if (pathname === LANDINGPAGE) {
            activeHomePage = true;
        } else if (pathname === GAMEPLAN) {
            activeGamePlanPage = true;
            activePerformanceMainMenu = true;
        } else if (pathname === STACKRANK) {
            activeStackRankPage = true;
            activePerformanceMainMenu = true;
        } else if (pathname === METRICSADMIN) {
            activeMetricsAdmin = true;
            activeAdmnMenu = true;
        } else if (pathname === ACTIONPLAN) {
            activeActionPlan = true;
            activeCoachingMenu = true;
        }
        setactivePerformanceMainMenu(activePerformanceMainMenu);
        // setActiveManagerMenu(managerLink);
        setActiveCompMenu(activeCompLink);
        setActiveScorecardRules(activeScorecardRule);
        setAdminWorkstreamPrep(activeAdmin);
        setCoachingView(activeCoaching);
        setCallInsightView(activeCallInsight);
        setActiveHomePageView(activeHomePage);
        setActiveMyMetricsLink(activeMyMetricsLink);
        setActiveScoreCardLink(activeScoreCardLink);
        setEdsLink(edsLink);
        setCompLink(activeCompLink);
        setActiveManagerLink(managerLink);
        setActiveCorrectiveActionMenu(activeCorrectiveAction);
        setActiveCaMenuLink(activeCaMenuLink);
        setGamePlanView(activeGamePlanPage);
        setStackRankView(activeStackRankPage);
        setActiveActionPlanLink(activeActionPlan);
        setVisibleContent(false);
        setSideNameContent(false);
        setActiveAdminMenu(activeAdmnMenu);
        setActiveMetricsAdminLink(activeMetricsAdmin);
        setActiveCoachingMenu(activeCoachingMenu);
        setCol1(1);
        setCol11(11);
        setCol6(12);
        setFirstCol('4%');
        setSecondCol('94.6%');
    }, [pathname]);

    const closeNavOnClickOutside = (event: any) => {
        const navElement = document.getElementById('sideBarMenu');
        if (navElement && !navElement.contains(event.target)) {
            setVisibleContent(false);
            setFirstCol('4%');
            setSecondCol('94.6%');
            document.removeEventListener('click', closeNavOnClickOutside);
        }
    };

    const handleToggle = (toggleState: boolean, menuType: string) => {
        setActivePerformanceView(menuType === 'performance' ? toggleState : !toggleState);
        // setActiveManagerView(menuType === 'manager' ? toggleState : !toggleState);
        setActiveCorrectiveActionView(menuType === 'correctiveAction' ? toggleState : !toggleState);
        setActiveCompView(menuType === 'compensation' ? toggleState : !toggleState);
        setActiveAdminView(menuType === 'admin' ? toggleState : !toggleState);
        setActiveCoachingView(menuType === 'coaching' ? toggleState : !toggleState);
        setVisibleContent(toggleState);
        setSideNameContent(toggleState);
        setCol1(toggleState ? 2 : 1);
        setCol11(toggleState ? 10 : 11);
        setCol6(toggleState ? 4 : 12);
        setFirstCol(toggleState ? '18%' : '4%');
        setSecondCol(toggleState ? '80%' : '94.6%');

        const toggleMenu = (menu: string) => {
            setactivePerformanceMainMenu(menu === 'performance');
            // setActiveManagerMenu(menu === 'manager');
            setActiveCompMenu(menu === 'compensation');
            setActiveCorrectiveActionMenu(menu === 'correctiveAction');
            setActiveAdminMenu(menu === 'admin');
            setActiveCoachingMenu(menu === 'coaching');
        };

        if (!toggleState) {
            toggleMenu('');
        } else {
            toggleMenu(menuType);
        }

        if (toggleState) {
            document.addEventListener('click', closeNavOnClickOutside);
        } else {
            document.removeEventListener('click', closeNavOnClickOutside);
        }
    };

    const openNav = () => {
        const toggleState = !sideNameContent;
        setTimeout(() => {
            handleToggle(toggleState, 'performance');
        }, 0);
    };

    // const openNavManagerView = () => {
    //     const toggleState = !sideNameContent;
    //     setTimeout(() => handleToggle(toggleState, 'manager'), 0);
    // };

    const openNavCompensationView = () => {
        const toggleState = !sideNameContent;
        setTimeout(() => handleToggle(toggleState, 'compensation'), 0);
    };

    const openNavAdminView = () => {
        const toggleState = !sideNameContent;
        setTimeout(() => handleToggle(toggleState, 'admin'), 0);
    };

    const openNavCoachingView = () => {
        const toggleState = !sideNameContent;
        setTimeout(() => handleToggle(toggleState, 'coaching'), 0);
    };

    const navigateUrl = (url: any) => {
        if (url === MYMETRICS) {
            setactivePerformanceMainMenu(true);
            setActiveMyMetricsLink(true);
            setActiveScoreCardLink(false);
            setEdsLink(false);
        } else if (url === SCORECARDDASHBOARD) {
            setactivePerformanceMainMenu(true);
            setActiveMyMetricsLink(false);
            setActiveScoreCardLink(true);
            setEdsLink(false);
        } else if (url === EDSDASHBOARD) {
            setactivePerformanceMainMenu(true);
            setActiveMyMetricsLink(false);
            setActiveScoreCardLink(false);
            setEdsLink(true);
        } else if (url === COMPENSATION) {
            setActiveCompMenu(true);
            setCompLink(true);
            // } else if (url === MANAGERDASHBOARD) {
            //     setActiveManagerMenu(true);
            //     setEdsLink(false);
        } else if (url === COACHING) {
            setCoachingView(true);
            setActiveCoachingMenu(true);
            setActiveActionPlanLink(false);
        } else if (url === ACTIONPLAN) {
            setActiveActionPlanLink(true);
            setActiveCoachingMenu(true);
            setCoachingView(false);
        } else if (url === CALLINSIGHT) {
            setCallInsightView(true);
        } else if (url === SCORECARDRULES) {
            setActiveScorecardRules(true);
        } else if (url === GAMEPLAN) {
            setGamePlanView(true);
        } else if (url !== SCORECARDRULES) {
            setActiveScorecardRules(false);
        } else if (url === ADMIN) {
            setActiveAdminMenu(true);
        } else if (url === LANDINGPAGE) {
            setActiveHomePageView(true);
        } else if (url === STACKRANK) {
            setStackRankView(true);
        }
        navigate(url);
    };

    const renderToolTips = () => {
        return MENUITEM_TOOL_TIPS.map((item: ItemToolTip) => {
            return (
                <Tooltip
                    mouseTrack
                    mouseTrackLeft={10}
                    mouseTrackTop={-20}
                    // key={item.title}
                    // key={`${item.title}-${role}-${empId}`}
                    key={`${item.title}-${new Date().getTime()}`}
                    target={item.targetClass}
                >
                    {item.title}
                </Tooltip>
            );
        });
    };

    const renderPerformanceMenu = () => {
        if (isEds && isDelegate) {
            return '';
        }

        // if ((role !== MANAGERROLE && !isComp) || isAdmin || isEds) {
        if (!isComp || isAdmin || isEds) {
            return (
                <button
                    className={`${activePerformanceMainMenu ? 'active' : ''} leftNavPerformanceBtn`}
                    onClick={openNav}
                >
                    <i className="leftNavPerformanceVectorLogo" />
                </button>
            );
        }
        return '';
    };

    return (
        <section className="bg-light">
            <div className="container">
                <div className="row bg-white">
                    {role === SUPERVISORROLE || role === AGENTROLE || role === MANAGERROLE ? (
                        <div
                            className={`col-md-${col1} d-flex align-items-stretch sidebar pe-0 ps-0 shadow-lg`}
                            style={{ width: firstCol }}
                        >
                            <div className="card border-0 w-100">
                                <div className="card-body d-flex flex-column p-0">
                                    <div className="row" style={{ height: '100vh' }}>
                                        <div className={`col-md-${col6} pe-0 pt-3`} style={{ width: '85px' }}>
                                            <div className="sideBarMenu" id="sideBarMenu">
                                                <div
                                                    style={{
                                                        padding: '10px',
                                                        paddingBottom: '50px',
                                                        textAlign: 'center',
                                                    }}
                                                >
                                                    <img src={ttcLogoUrl} alt="TTEC Logo" />
                                                </div>
                                                {(role === SUPERVISORROLE || role === AGENTROLE || (role === MANAGERROLE && (isManagerRecentApprover || isAllowCoachingActionModel))) && (
                                                    <button
                                                        className={`${activeHomePageView ? 'active' : ''
                                                            } leftNavHomeViewLogo`}
                                                        onClick={() => navigateUrl(LANDINGPAGE)}
                                                    >
                                                        <i className="leftNavHomeViewLogo" />
                                                    </button>
                                                )}
                                                {<div>{renderPerformanceMenu()}</div>}
                                                {/* {role === MANAGERROLE || isAdmin ? (
                                                    <button
                                                        className={`${
                                                            activeManagerMenu ? 'active' : ''
                                                        } leftNavManagerViewBtn`}
                                                        onClick={openNavManagerView}
                                                    >
                                                        <i className="leftNavManagerViewLogo" />
                                                    </button>
                                                ) : (
                                                    ''
                                                )} */}

                                                {isComp || isAdmin ? (
                                                    <button
                                                        className={`${activeCompMenu ? 'active' : ''
                                                            } leftNavCompViewLogo`}
                                                        onClick={openNavCompensationView}
                                                    >
                                                        <i className="leftNavCompViewLogo" />
                                                    </button>
                                                ) : (
                                                    ''
                                                )}
                                                {role === MANAGERROLE || isComp || isEds || isAdmin ? (
                                                    <button
                                                        className={`${activeScorecardRules ? 'active' : ''
                                                            } leftScorecardRulesLogo`}
                                                        onClick={() => navigateUrl(SCORECARDRULES)}
                                                    >
                                                        <i className="leftScorecardRulesLogo" />
                                                    </button>
                                                ) : (
                                                    ''
                                                )}
                                                <button
                                                    className={`${activeCorrectiveActionMenu ? 'active' : ''
                                                        } leftCorrectiveActionsLogo`}
                                                    onClick={() => navigateUrl(CAMENU)}
                                                >
                                                    <i className="leftCorrectiveActionsLogo" />
                                                </button>
                                                {isAdmin || isHC ? (
                                                    <button
                                                        className={`${activeAdminMenu ? 'active' : ''
                                                            } leftAdminWorkstreamLogo`}
                                                        onClick={openNavAdminView}
                                                    >
                                                        <i className="leftAdminWorkstreamLogo" />
                                                    </button>
                                                ) : (
                                                    ''
                                                )}

                                                {role === SUPERVISORROLE ||
                                                    role === AGENTROLE ||
                                                    role === MANAGERROLE ||
                                                    isHC ||
                                                    isAdmin ? (
                                                    <button
                                                        className={`${activeCoachingMenu ? 'active' : ''
                                                            } leftCoachingLogo`}
                                                        onClick={openNavCoachingView}
                                                    >
                                                        <i className="leftCoachingLogo" />
                                                    </button>
                                                ) : (
                                                    ''
                                                )}

                                                {((isAllowCoachingInsight === true &&
                                                    !ROLES.Agents.includes(userManagerLevel)) ||
                                                    ROLES.DirectorOrAbove.includes(userManagerLevel)) && (
                                                        <button
                                                            className={`${callInsightView ? 'active' : ''
                                                                } leftCallInsightLogo`}
                                                            onClick={() => navigateUrl(CALLINSIGHT)}
                                                        >
                                                            <i className="leftCallInsightLogo" />
                                                        </button>
                                                    )}
                                            </div>
                                        </div>

                                        <div
                                            className={`col-md-8 border-start pt-4 navBarContent ${visibleContent ? 'slideIn' : 'slideOut'
                                                }`}
                                        >
                                            <div className="menuContent pt-2">
                                                {activePerformanceView ? (
                                                    <div className="performanceContent">
                                                        <h6 className="pb-3">Performance</h6>
                                                        <div className="ps-2">
                                                            {(!isEds && role !== MANAGERROLE && !isComp) ||
                                                                (role !== MANAGERROLE && isAdmin) ? (
                                                                <div>
                                                                    <button
                                                                        className={`${activeMyMetricsLink
                                                                                ? 'active'
                                                                                : ''
                                                                            } myMetricsBtn`}
                                                                        onClick={() => navigateUrl(MYMETRICS)}
                                                                    >
                                                                        <i className="pe-1 myMetricsBtnIcon" />{' '}
                                                                        My Metrics
                                                                    </button>
                                                                </div>
                                                            ) : (
                                                                ''
                                                            )}

                                                            {isAllowCoachingInsight &&
                                                                ROLES.Agents.includes(userManagerLevel) ? (
                                                                <div>
                                                                    <button
                                                                        className={`${callInsightView ? 'active' : ''
                                                                            } leftCallInsightLogo`}
                                                                        onClick={() =>
                                                                            navigateUrl(CALLINSIGHT)
                                                                        }
                                                                    >
                                                                        <i className="leftCallInsightLogo" />{' '}
                                                                        Call Insight
                                                                    </button>
                                                                </div>
                                                            ) : (
                                                                ''
                                                            )}

                                                            {(role === SUPERVISORROLE && !isEds && !isComp) ||
                                                                (role === SUPERVISORROLE && isAdmin) ? (
                                                                <button
                                                                    className={`${activeScoreCardLink ? 'active' : ''
                                                                        } mt-2 scorecardBtn`}
                                                                    onClick={() =>
                                                                        navigateUrl(SCORECARDDASHBOARD)
                                                                    }
                                                                >
                                                                    <i className="pe-1 scorecardBtnIcon" />{' '}
                                                                    Scorecard
                                                                </button>
                                                            ) : (
                                                                ''
                                                            )}

                                                            {role === MANAGERROLE || isAdmin ? (
                                                                <>
                                                                    <button
                                                                        className={`${activeManagerLink ? 'active' : ''
                                                                            } mt-2 managerViewBtn`}
                                                                        onClick={() =>
                                                                            navigateUrl(MANAGERDASHBOARD)
                                                                        }
                                                                    >
                                                                        <i className="pe-1 managerViewBtnIcon" />{' '}
                                                                        Manager View
                                                                    </button>

                                                                    {/* {
                                                                        <button
                                                                            className={`${
                                                                                stackRankView ? 'active' : ''
                                                                            } mt-2 leftStackRankLogo`}
                                                                            onClick={() =>
                                                                                navigateUrl(STACKRANK)
                                                                            }
                                                                        >
                                                                            <i className="pe-1 leftStackRankLogo" />{' '}
                                                                            Stack Rank
                                                                        </button>
                                                                    } */}
                                                                </>
                                                            ) : (
                                                                ''
                                                            )}

                                                            {((role === SUPERVISORROLE ||
                                                                role === AGENTROLE || role === MANAGERROLE) &&
                                                                !isComp) ||
                                                                (role === SUPERVISORROLE && isAdmin) ? (
                                                                <button
                                                                    className={`${stackRankView ? 'active' : ''
                                                                        } mt-2 leftStackRankLogo`}
                                                                    onClick={() => navigateUrl(STACKRANK)}
                                                                >
                                                                    <i className="pe-1 leftStackRankLogo" />{' '}
                                                                    Stack Rank
                                                                </button>
                                                            ) : (
                                                                ''
                                                            )}

 
                                                            {
                                                                //     ( (role === SUPERVISORROLE && !isEds && !isComp) ||
                                                                // (role === SUPERVISORROLE && isAdmin))
                                                                (ROLES.SupervisorORManager.includes(
                                                                    userManagerLevel
                                                                ) && isUserinPercepta !== true && isAllowCoachingActionModel === false) ? (
                                                                    <button
                                                                        className={`${gamePlanView ? 'active' : ''
                                                                            } mt-2 leftGamePlanLogo`}
                                                                        onClick={() => navigateUrl(GAMEPLAN)}
                                                                    >
                                                                        <i className="pe-1 leftGamePlanLogo" />{' '}
                                                                        Gameplan
                                                                    </button>
                                                                ) : (
                                                                    ''
                                                                )
                                                            }

                                                            {(isEds && !isDelegate) || isAdmin ? (
                                                                <button
                                                                    className={`${activeEdsLink ? 'active' : ''
                                                                        } mt-2 dataBtn`}
                                                                    onClick={() => navigateUrl(EDSDASHBOARD)}
                                                                >
                                                                    <i className="pe-1 dataBtnIcon" /> Data
                                                                </button>
                                                            ) : (
                                                                ''
                                                            )}
                                                        </div>
                                                    </div>
                                                ) : (
                                                    ''
                                                )}
                                                {/* {activeManagerView ? (
                                                    <div className="performanceContent">
                                                        <h6 className="pb-3">Manager View</h6>
                                                        <div className="ps-2">
                                                            {role === MANAGERROLE || isAdmin ? (
                                                                <>
                                                                    <button
                                                                        className={`${
                                                                            activeManagerLink ? 'active' : ''
                                                                        } mt-2 managerViewBtn`}
                                                                        onClick={() =>
                                                                            navigateUrl(MANAGERDASHBOARD)
                                                                        }
                                                                    >
                                                                        <i className="pe-1 managerViewBtnIcon" />{' '}
                                                                        Manager View
                                                                    </button>

                                                                    {
                                                                        <button
                                                                            className={`${
                                                                                stackRankView ? 'active' : ''
                                                                            } mt-2 leftStackRankLogo`}
                                                                            onClick={() =>
                                                                                navigateUrl(STACKRANK)
                                                                            }
                                                                        >
                                                                            <i className="pe-1 leftStackRankLogo" />{' '}
                                                                            Stack Rank
                                                                        </button>
                                                                    }
                                                                </>
                                                            ) : (
                                                                ''
                                                            )}
                                                        </div>
                                                    </div>
                                                ) : (
                                                    ''
                                                )} */}
                                                {activeCompView ? (
                                                    <div className="performanceContent">
                                                        <h6 className="pb-3">Compensation View</h6>
                                                        <div className="ps-2">
                                                            {isAdmin || isComp ? (
                                                                <button
                                                                    className={`${activeCompLink ? 'active' : ''
                                                                        } mt-2 compensationBtnIcon`}
                                                                    onClick={() => navigateUrl(COMPENSATION)}
                                                                >
                                                                    <i className="pe-1 compensationBtnIcon" />{' '}
                                                                    Overview
                                                                </button>
                                                            ) : (
                                                                ''
                                                            )}
                                                        </div>
                                                    </div>
                                                ) : (
                                                    ''
                                                )}
                                                {activeCorrectiveActionView ? (
                                                    <div className="performanceContent">
                                                        <h6 className="pb-3">Corrective Actions</h6>
                                                        <div className="ps-2">
                                                            {role === SUPERVISORROLE ||
                                                                role === AGENTROLE ||
                                                                role === MANAGERROLE ? (
                                                                <button
                                                                    className={`${activeCaMenuLink ? 'active' : ''
                                                                        } mt-2 myCorrectiveActionAssignmentBtn`}
                                                                    onClick={() => navigateUrl(CAMENU)}
                                                                >
                                                                    <i className="pe-1 myCorrectiveActionAssignmentBtnIcon" />{' '}
                                                                    CA Menu
                                                                </button>
                                                            ) : (
                                                                ''
                                                            )}
                                                        </div>
                                                    </div>
                                                ) : (
                                                    ''
                                                )}
                                                {activeAdminView ? (
                                                    <div className="performanceContent">
                                                        <h6 className="pb-3">Admin View</h6>
                                                        <div className="ps-2">
                                                            {isAdmin || isHC ? (
                                                                <>
                                                                    <button
                                                                        className={`${adminWorkstreamPrep ? 'active' : ''
                                                                            } mt-2 leftCAAdminLogo`}
                                                                        onClick={() => navigateUrl(ADMIN)}
                                                                    >
                                                                        <i className="pe-1 leftCAAdminLogo" />{' '}
                                                                        Corrective Actions
                                                                    </button>

                                                                    <button
                                                                        className={`${activeMetricsAdminLink ? 'active' : ''
                                                                            } mt-2 leftMetricsAdminLogo`}
                                                                        onClick={() => navigateUrl(METRICSADMIN)}
                                                                    >
                                                                        <i className="pe-1 leftMetricsAdminLogo" />{' '}
                                                                        Metrics Admin
                                                                    </button>
                                                                </>
                                                            ) : (
                                                                ''
                                                            )}
                                                        </div>
                                                    </div>
                                                ) : (
                                                    ''
                                                )}
                                                {activeCoachingView ? (
                                                    <div className="performanceContent">
                                                        <h6 className="pb-3">Coaching</h6>
                                                        <div className="ps-2">
                                                            <button
                                                                className={`${coachingView ? 'active' : ''} mt-2`}
                                                                onClick={() => navigateUrl(COACHING)}
                                                            >
                                                                <i className="pe-1 leftCoachingLogo" /> Coaching Tools
                                                            </button>
                                                            {isAllowCoachingActionModel === true && (role === SUPERVISORROLE || role === AGENTROLE || role === MANAGERROLE) ? (
                                                                <button
                                                                    className={`${activeActionPlanLink ? 'active' : ''} mt-2`}
                                                                    onClick={() => navigateUrl(ACTIONPLAN)}
                                                                >
                                                                    <i className="leftActionPlanIcon" /> Action Plans
                                                                </button>
                                                            ) : null}
                                                        </div>
                                                    </div>
                                                ) : (
                                                    ''
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        ''
                    )}

                    <div
                        className={`col-md-${col11} d-flex align-items-stretch p-0`}
                        style={{ width: secondCol }}
                    >
                        <div className="card border-0 w-100">
                            <div className="card-body d-flex flex-column p-0">
                                <Header />
                                <main className="container worldMapBg mb-5 pe-0">
                                    <Outlet />
                                </main>
                                <Footer />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {(role === SUPERVISORROLE || role === AGENTROLE || role === MANAGERROLE) && renderToolTips()}

            {empId && isUserMoodMeterHidden === false && <LeftDrawerEmojis empId={empId} role={role} />}

            {currentUserName && empId && role && role.length > 0 && process.env.REACT_APP_WEBRTC_URL && <WebRtcDashboard />}
        </section>
    );
};
